/**
 * Stable reason the screener API attaches to the 409 body when a candidate
 * hits a paused location. Mirrors the backend `PAUSED_LOCATION_REASON`; the two
 * live in independent services, so the string is intentionally duplicated here
 * rather than imported across the service boundary.
 */
export const LOCATION_PAUSED_REASON = "location_paused";

/** True when an API error is the paused-location 409 from the screener API. */
export const isLocationPausedError = (error: unknown): boolean =>
  (error as { response?: { data?: { reason?: string } } })?.response?.data
    ?.reason === LOCATION_PAUSED_REASON;
